import { Helmet } from 'react-helmet-async';
import { useSite } from '../../contexts/SiteContext';

/**
 * Injects the MAP tracker SDK into the page <head> when a tracking write key
 * is configured for this space. Uses the external /public/track.js script
 * (same SDK as the install snippet shown in Space Settings).
 *
 * Must be rendered inside <SiteProvider> so useSite() has access to the key.
 */
export function TrackingHead() {
  const { trackingWriteKey } = useSite();
  if (!trackingWriteKey) return null;

  return (
    <Helmet>
      {/* Load the MAP tracker SDK */}
      <script src="/public/track.js" defer />
      {/* Initialise after the script has loaded */}
      <script>{`window.addEventListener('load',function(){typeof MAP==='function'&&MAP('init',${JSON.stringify(trackingWriteKey)});})`}</script>
    </Helmet>
  );
}
